import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  projectExpense: Boundaries["removeProjectExpense"]["request"],
): State {
  const index = state.findIndex(
    (req) => req.projectExpense.uuid === projectExpense.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { projectExpense, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { projectExpense, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  projectExpense: Boundaries["removeProjectExpense"]["success"],
): State {
  const index = state.findIndex(
    (req) => req.projectExpense.uuid === projectExpense.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { projectExpense, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { projectExpense, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  projectExpense: Boundaries["removeProjectExpense"]["failure"],
): State {
  const index = state.findIndex(
    (req) => req.projectExpense.uuid === projectExpense.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { projectExpense, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { projectExpense, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeProjectExpenseRequested]: handleRequest,
    [events.removeProjectExpenseSucceeded]: handleSuccess,
    [events.removeProjectExpenseFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
